// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1208":"e889424ab47f30c2","3727":"bbb4216e5f06cb89","7977":"582b3ef667b7ad0e","8506":"c422b76e712f4c06"}[chunkId] + ".js";
};